import React, { useContext, useEffect } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FocusLock from 'react-focus-lock';
import { TranslatorContext } from '@jutro/locale';
import { IconButton } from '@jutro/components';
import styles from "./BurgerMenu.module.css";
import { messages } from './BurgerMenu.messages';
import { BurgerMenuItem } from './BurgerMenuItem';
const BurgerSidebarInternal = ({
  isOpen,
  setIsOpen,
  burgerContent
}) => {
  const translator = useContext(TranslatorContext);
  const visibilityStyles = {
    [styles.isClosed]: !isOpen
  };
  const sidebarClassNames = cx(styles.burgerSidebar, visibilityStyles);
  const backdropClassNames = cx(styles.backdrop, visibilityStyles);
  const closeOnClick = () => {
    setIsOpen(false);
  };
  const location = useLocation();
  useEffect(closeOnClick, [location.pathname]);
  const burgerSidebarHeader = React.createElement(BurgerMenuItem, {
    id: "burger-menu-side-bar-header",
    className: styles.sidebarHeader,
    hideSeparator: true,
    isContainerOnly: true
  }, React.createElement("span", {
    className: styles.menu
  }, translator(messages.menuHeaderTitle)), React.createElement(IconButton, {
    icon: "mi-close",
    iconColor: "dark",
    onClick: closeOnClick,
    "aria-label": translator(messages.closeNavigationLabel)
  }));
  const focusLockWhiteList = node => {
    var _document$getElementB;
    return (_document$getElementB = document.getElementById('appSwitcherModal')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.contains(node);
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: sidebarClassNames,
    "aria-hidden": !isOpen
  }, React.createElement(FocusLock, {
    noFocusGuards: true,
    whiteList: focusLockWhiteList
  }, burgerSidebarHeader, burgerContent)), React.createElement("div", {
    className: backdropClassNames,
    onClick: closeOnClick,
    role: "presentation"
  }));
};
BurgerSidebarInternal.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
  burgerContent: PropTypes.arrayOf(PropTypes.node)
};
BurgerSidebarInternal.defaultProps = {
  isOpen: false
};
BurgerSidebarInternal.displayName = 'BurgerSidebar';
export const BurgerSidebar = withRouter(BurgerSidebarInternal);
BurgerSidebarInternal.__docgenInfo = {
  componentName: "BurgerSidebar",
  packageName: "@jutro/router",
  description: "BurgerSidebar renders content of burger menu in a sidebar",
  displayName: "BurgerSidebar",
  methods: [],
  actualName: "BurgerSidebarInternal",
  metadataType: "container",
  props: {
    isOpen: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Sidebar state",
      defaultValue: {
        value: "false",
        computed: false
      }
    },
    setIsOpen: {
      type: {
        name: "func"
      },
      required: false,
      description: "Sidebar set state function"
    },
    burgerContent: {
      type: {
        name: "arrayOf",
        value: {
          name: "node"
        }
      },
      required: false,
      description: "Sidebar content"
    }
  }
};